var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-file-input',{staticStyle:{"display":"none"},attrs:{"disabled":_vm.disabled,"accept":_vm.accept,"readonly":_vm.readonly,"id":_vm.InputId},model:{value:(_vm.Selected),callback:function ($$v) {_vm.Selected=$$v},expression:"Selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }